/**
 * Given a disambiguated filters object, returns the dynamic title to use for
 * the table.
 * @param {object} disambiguatedFilters - A disambiguated filters object describing current filters.
 * @returns {string} The table title.
 */
const getTableTitle = (disambiguatedFilters) => {
  const {
    serviceType,
    sourceOfFunds,
    yearCompare,
    yearRange,
    yearSingle,
    yearType,
  } = disambiguatedFilters;

  // Output format depends on year type.
  switch (yearType) {
    case 'Custom Range':
      return `${serviceType.join(', ')} Spending by ${sourceOfFunds.join(', ')}, ${yearRange[0]}-${yearRange[1]}`;
    case 'Compare Two Years':
      return `${serviceType.join(', ')} Spending by ${sourceOfFunds.join(', ')}, ${yearCompare[0]} compared with ${yearCompare[1]}`;
    case 'Single Year':
      return `${serviceType.join(', ')} Spending by ${sourceOfFunds.join(', ')}, ${yearSingle}`;
    default:
      return '';
  }
};

export default getTableTitle;
